/**
 * Search / template UI/UX
 */

'use strict';

var helper = require('../misc/helpers');

// Constructor
var FrontSearch = function () {
    $(document).ready((function() {
        this.reinitializeSearch();
        this.mobileSearch();
    }).bind(this));
};

FrontSearch.prototype = {
    reinitializeSearch: function() {
        $('.reinit').on('click', function() {
            window.location.reload();
        });
    },

    mobileSearch: function() {
        var self = this;

        $('#search-box-mobile-btn a').on('click', function(e) {
            e.preventDefault();

            if ($('body').hasClass('home')) {
                window.location.replace(comedien.actorsListing + '#searchForm');
                return;
            }

            if (!$('#search-box-mobile').hasClass('body')) {
                // Move the search fields in the body
                $('body').append($('#search-box-mobile'));
            }

            // Disable the scroll for the site wrapper
            $('body').css('position', 'fixed');
            $('body').css('overflow', 'hidden');

            // Hide Google Translate button
            $('.goog-te-ftab-float').hide();

            // Slide animation
            $('#search-box-mobile').css('margin-top', $(window).height()).addClass('visible').addClass('body');
            $('#search-box-mobile').animate({'margin-top': '0px'}, 750);

        });

        $('body').on('click', '#search-box-mobile .close-search', function(e) {
            e.preventDefault();

            // Enable the scroll for the site wrapper
            $('body').css('position', '');
            $('body').css('overflow', '');

            // Hide Google Translate button
            $('.goog-te-ftab-float').show();

            $('#search-box-mobile').css('margin-top', '').removeClass('visible');
        });

        $('body').on('click', '#search-box-mobile .btn-submit', function(e) {
            e.preventDefault();

            self.uiMobileSearched();

            $('#search-box-mobile form').first().trigger('submit');
        });

        $('body').on('click', '#search-box-mobile .btn-reinit', function(e) {
            e.preventDefault();

            $('#search-box-mobile').removeClass('searched');
            $('#search-box-mobile-btn a').removeClass('searched');
            $('#search-box-mobile-btn a span').text($('#search-box-mobile-btn a span').data('search'));
        });
    },

    uiMobileSearched: function() {
        $('#search-box-mobile').addClass('searched');
        $('#search-box-mobile-btn a').addClass('searched');
        $('#search-box-mobile-btn a span').text($('#search-box-mobile-btn a span').data('searched'));
    }
};

module.exports = new FrontSearch();
